/**
 * Manages the react-dnd logic for the desktop panel, allowing it to
 * act as a drop target for controls being returned from the mobile canvas.
 */
import { useDrop } from 'react-dnd';

export const useDesktopDropTarget = (removeControl, activePageId) => {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: 'MOBILE_OBJECT',
        drop: (item) => removeControl({ pageId: activePageId, controlId: item.id }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [removeControl, activePageId]);

    return { isOver, canDrop, drop };
};